var layout_default = {
  "layout": "HUdfu",
  "cell": "GbNOh"
};
export {
  layout_default as default
};
//# sourceMappingURL=layout-scss.js.map
